module.exports = __webpack_public_path__ + "img/UnionPay_logo.9b59a572.svg";